import React from 'react'
import PowerBIResource from '../../containers/resourceCatalog/catalogItem/CatalogContainer.models'

import CatalogItemContainer from '../../containers/resourceCatalog/catalogItem/CatalogItemContainer'
import './ResourceCatalog.css'

const ResourceCatalog = ({ resources }: { resources: PowerBIResource[] }) => {
  return (
    <div id="catalog">
      {resources.length > 0 ? (
        <div className="catalog-section">
          <div className="catalog-boxes">
            {resources.map((resource, i) => (
              <CatalogItemContainer {...resource} key={i} />
            ))}
          </div>
        </div>
      ) : (
        <span>
          There are no resources currently available. Please contact your system
          administrator for more information.
        </span>
      )}
    </div>
  )
}

export default ResourceCatalog
